module.exports = __webpack_public_path__ + "img/30.6cff2ece.jpg";